<template lang="pug">
.relative
  // nav
  .gl-nav(v-gl-wl="{ apply: [ 'headerBgColor', 'headerBorderColor' ] }" layout="row" layout-align="space-between start")
    // left
    .gl-nav__left(layout="row" layout-align="start start")

      // logo
      router-link(:to="{ name: 'dashboard' }")
        .gl-nav__logo(v-gl-wl="{ apply: 'headerBorderColor' }" @click="scrollTop" layout="column" layout-align="center center")
          img(v-gl-wl="{ insert: 'headerLogo' }")

      // group
      .gl-nav__group(v-if="route.name === 'dashboard' && group" v-gl-wl="{ apply: 'headerBorderColor' }" layout="row" layout-align="center center")
        b-dropdown.gl-nav__profile__dropdown-trigger(
          v-if="groups.user && groups.user.length > 1"
          @shown="isDropdownOpen.group = true"
          @hidden="isDropdownOpen.group = false"
          variant="link" size="lg" no-caret)
          b-dropdown-item(v-for="g in groups.user" v-bind:class="{ 'active': g && group && g.id === group.id }" :key="g.id" @click="commitGroup(g.id)" href="javascript:void(0)")
            font-awesome-icon(v-if="group && g.id === group.id" icon="check")
            span {{ g.name }}
        .gl-nav__group__logo(v-if="group.id")
          gl-group-logo(:group-id="group.id")
        .gl-nav__group__name(v-if="group" v-gl-wl="{ apply: [ 'headerTextColor', 'headerFontWeight' ] }") {{ group.name }}
        .gl-nav__arrow(v-if="groups.user && groups.user.length > 1")
          font-awesome-icon(:class="{ 'flip': isDropdownOpen.group === true }" v-gl-wl="{ apply: 'headerTextColor' }" icon="chevron-down")

      // dashboard
      .gl-nav__dashboard(v-if="route.name === 'dashboard' && group && dashboard.meta" v-gl-wl="{ apply: 'headerBorderColor' }" layout="row" layout-align="center center")
        b-dropdown.gl-nav__profile__dropdown-trigger(
          v-if="dashboards.byGroup.length > 1"
          @shown="isDropdownOpen.dashboard = true"
          @hidden="isDropdownOpen.dashboard = false"
          variant="link" size="lg" no-caret)
          b-dropdown-item(v-for="d in dashboards.byGroup" v-bind:class="{ 'active': d && dashboard.meta && d.id === dashboard.meta.id && d.type === dashboard.meta.type }" :key="d.id + '-' + d.type" @click="commitDashboard(d); bind" href="javascript:void(0)")
            font-awesome-icon(v-if="d && dashboard.meta && d.id === dashboard.meta.id && d.type === dashboard.meta.type" icon="check")
            span {{ d.name }}
        .gl-nav__dashboard__icon.hide
        .gl-nav__dashboard__name(v-if="dashboard.meta" v-gl-wl="{ apply: [ 'headerTextColor', 'headerFontWeight' ] }") {{ dashboard.meta.name }}
        .gl-nav__arrow(v-if="dashboards.byGroup.length > 1")
          font-awesome-icon(:class="{ 'flip': isDropdownOpen.dashboard === true }" v-gl-wl="{ apply: 'headerTextColor' }" icon="chevron-down")

    // right
    .gl-nav__right(layout="row")
      // report parameters
      .gl-nav__report-params-toggle(@click="toggleReportParams" v-if="showParams && route.name === 'dashboard' && dashboard.meta && dashboard.meta.type === 'mode'" v-gl-wl="{ apply: 'headerBorderColor' }" layout="row" layout-align="center center")
        .gl-nav__report-params-toggle__icon
          img(src="~@/assets/icons/filter.svg")
        .gl-nav__report-params-toggle__label(v-gl-wl="{ apply: [ 'headerTextColor', 'headerFontWeight' ] }") Report Parameters

      // export csv
      a#csv-export-link.gl-nav__toggle-filters(v-if="!dashboard.isLoading && route.name === 'dashboard' && dashboard.meta && dashboard.meta.type === 'mode'" v-gl-wl="{ apply: 'headerBorderColor', removeIf: 'hideExport' }" layout="row" layout-align="center center")
        .gl-nav__toggle-filters__icon
          font-awesome-icon(v-gl-wl="{ apply: 'headerTextColor' }" icon="download")
        .gl-nav__toggle-filters__label(v-gl-wl="{ apply: [ 'headerTextColor', 'headerFontWeight' ] }") Export CSV

      // profile
      .gl-nav__profile(v-gl-wl="{ apply: 'headerBorderColor' }" layout="row" layout-align="center center")
        b-dropdown.gl-nav__profile__dropdown-trigger(variant="link" size="lg" no-caret)
          router-link(:to="{ name: 'settings-general' }" v-if="!route.isSettingsPage" v-gl-admin-only="true")
            b-dropdown-item(href="javascript:void(0)") App Settings
          router-link(:to="{ name: 'dashboard' }" v-if="route.name !== 'dashboard'")
            b-dropdown-item(href="javascript:void(0)") Back to Dashboards
          router-link(:to="{ name: 'update-password' }")
            b-dropdown-item(href="javascript:void(0)" v-if="route.name !== 'update-password'") Update Password
          b-dropdown-item(href="javascript:void(0)" @click="logout") Sign Out
        .gl-nav__profile__avatar(v-if="user")
          img(:src="user.email | gravatar")
        .gl-nav__profile__right(v-if="user")
          .gl-nav__profile__name(v-gl-wl="{ apply: 'headerTextColor' }") {{ user.firstName }} {{ user.lastName }}
          .gl-nav__profile__email(v-gl-wl="{ apply: 'headerTextColor' }") {{ user.email }}

    // changes
    .gl-nav__changes(:style="{ paddingLeft: changes.paddingLeft, paddingRight: changes.paddingRight }" v-if="options && options.unsavedChanges" layout="row" layout-align="space-between center")
      .gl-nav__changes__message Unsaved changes
      .gl-nav__changes__btns(layout="row" layout-align="end center")
        gl-btn.mr-12(:options="{ label: 'Cancel', type: 'button', style: 'gradient' }" @click.native="cancelChanges")
        gl-btn(:options="{ label: 'Save', type: 'button', style: 'brand-settings', isLoading: options.isLoading }"  @click.native="submitChanges")

  // params
  .gl-report-params(:style="{ height: paramHeight }" v-if="showParams && areParamsVisible && !route.isSettingsPage")
    // header
    .gl-report-params__header(layout="row" layout-align="space-between")
      .gl-report-params__header__title Report Parameters
      gl-btn.gl-report-params__header__close(@click.native="toggleReportParams" :options="{ fa: 'times', type: 'button', style: 'transparent' }")

    // form
    form.gl-report-params__form(@submit.prevent="runReport" layout="row")
      div(layout="row" layout-wrap)
        .gl-report-params__form__param(:key="param.name" v-for="param in params" v-if="param.display")

          // text || date
          b-form-group(:state="param.state" :label="param.label" :label-for="param.name" v-if="param.type === 'text' || param.type === 'date'")
            b-form-input(
              :name="param.name"
              :type="param.type"
              :state="param.state"
              v-model.trim="paramValues[ param.name ]"
              required)
            .invalid-feedback(v-if="param.invalidFeedback") {{ param.invalidFeedback }}

          // select
          b-form-group(v-if="param.type === 'select'" :label="param.label")

            multiselect(
              :state="param.state"
              :options="param.$options"
              :multiple="false"
              :clear-on-select="true"
              @open="bindParamHeight"
              @close="bindParamHeight"
              @select="bindParamHeight"
              open-direction="bottom"
              label="text"
              track-by="value"
              v-model="paramValues[ param.name ]"
              placeholder="Please select an option"
              required)

          // multiselect
          div(v-if="param.type === 'multiselect'")
            label.col-form-label.pt-0 {{ param.label }}
            multiselect(
              :state="param.state"
              :options="param.$options"
              :close-on-select="false"
              :multiple="true"
              :clear-on-select="true"
              :group-select="true"
              @open="bindParamHeight"
              @close="bindParamHeight"
              @select="bindParamHeight"
              group-values="vs"
              group-label="all"
              open-direction="bottom"
              label="text"
              track-by="value"
              v-model="paramValues[ param.name ]"
              placeholder="Please select options"
              select-group-label="Press enter to select all"
              deselect-group-label="Press enter to deselect all"
              required)

              template(slot="selection" slot-scope="{ values, search, isOpen }")
                span(v-if="values.length && !isOpen") {{ values.length }} options selected

            .invalid-feedback(v-if="param.invalidFeedback") {{ param.invalidFeedback }}

      // submit button
      .gl-report-params__form__btn-wrapper(v-if="showRunReportButton" layout="column" layout-align="end end")
        gl-btn(:options="{ label: 'Run Report', type: 'submit', style: 'brand' }")
</template>

<script>
import Vue from 'vue'
import $ from 'jQuery'
import _ from 'lodash'
import { mapGetters } from 'vuex'

export default {

  // props
  props: {
    options: Object
  },

  // computed
  computed: {
    ...mapGetters(['user', 'group', 'dashboard', 'groups', 'dashboards']),
    params () {
      this.bindParamHeight()

      return _.reduce(this.dashboard.meta.formFields, (r, formField, key) => {
        switch (formField.type) {
          case 'select':
            formField.$options = _.map(formField.options, (option) => {
              if (_.isArray(option)) return { text: option[0], value: String(option[1]) }
              else if (_.has(option, 'value')) return { text: option.text, value: String(option.value) }
            })

            if (!this.paramValues[key]) formField.$val = _.find(formField.$options, { value: _.has(formField, 'value.value') ? formField.value.value : formField.value })
            break

          case 'multiselect':
            formField.$options = [
              {
                all: 'Select All',
                vs: _.map(formField.options, (option) => {
                  if (_.isArray(option)) return { text: option[0], value: String(option[1]) }
                  else if (_.has(option, 'value')) return { text: option.text, value: String(option.value) }
                })
              }
            ]

            if (!this.paramValues[key]) {
              formField.$val = []

              _.forEach(formField.value, (v) => {
                let newValue = _.find(formField.$options[0].vs, { value: _.has(v, 'value') ? v.value : v })
                if (newValue) formField.$val.push(newValue)
              })
            }
            break
        }

        // add form field to params
        r[ formField.name ] = formField

        // if param value is undefined -> add param value
        if (!this.paramValues[ formField.name ]) this.$set(this.paramValues, formField.name, formField.$val || formField.value || formField.default)

        return r
      }, {})
    },
    showRunReportButton () {
      return Boolean(_.keys(this.params).length)
    },
    showParams () {
      let visible = []

      _.forEach(_.get(this, 'dashboard.meta.formFields'), (field) => {
        if (field.display) visible.push(field)
      })

      return Boolean(visible.length && !this.dashboard.isLoading)
    }
  },

  // data
  data () {
    return {
      errors: [],
      paramValues: {},
      destroyResize: null,
      paramHeight: '147px',
      areParamsVisible: false,
      changes: {
        paddingLeft: '',
        paddingRight: ''
      },
      isDropdownOpen: {
        group: false,
        dashboard: false
      },
      route: {
        name: '',
        isSettingsPage: true
      }
    }
  },

  // on mount
  mounted () {
    // set route
    this.setRoute()

    // after each page transition => set route
    this.$router.afterEach(() => this.setRoute())

    // if on dashboard page
    if (this.route.name === 'dashboard') {
      // get fresh groups
      this.$glAuth.getUserGroups()
        .then(() => {
          // if: no group -> commit first group
          if (!_.isObject(this.group)) return this.$glAuth.commitFirstGroup()
        })
        .catch(e => console.log('er: gl-nav: ', e))

      // get current dash
      const currentDash = _.get(this, '$store.getters.dashboard.meta')

      // reset dash url
      if (_.isObject(currentDash)) currentDash.url = null

      // store: clear store dashboard
      this.$store.commit('dashboard', {
        meta: currentDash,
        is404: false,
        isLoading: true
      })

      // get fresh dashboards
      this.$glAuth.getActiveDashboards()
        .then(() => {
          // if: no dashboard -> commit first dashboard
          // else -> commit currentDash
          if (!currentDash) return this.$glAuth.commitFirstDashboard()
          else if (currentDash.id) return this.commitDashboard(currentDash)
        })
        .catch(e => console.log('er: gl-nav: ', e))
        // .finally(() => this.bindParams())

      // if not a settings page -> bind window resize event
      if (!this.route.isSettingsPage) {
        this.destroyResize = this.$glDom.onResize({
          namespace: 'gl-nav--resize',
          debounce: 100,
          callback: this.bindParamHeight
        })
      }
    }
  },

  // on destroy
  destroyed () {
    if (_.isFunction(this.destroyResize)) this.destroyResize()
  },

  // watch
  watch: {
    'options.unsavedChanges' () {
      // add 24px to the logo width
      this.changes.paddingLeft = ($('.gl-nav__logo').outerWidth() + 24) + 'px'

      // add 24px to the right profile width
      this.changes.paddingRight = ($('.gl-nav__profile').outerWidth() + 24) + 'px'
    }
  },

  // methods
  methods: {
    logout () {
      // logout
      this.$glAuth.logout()

      // return to login page
      this.$router.push('login')
    },
    commitGroup (groupId) {
      // commit group
      this.$glAuth.commitGroup(groupId)

      // close dropdown
      this.isDropdownOpen.group = false
    },
    commitDashboard (dashboard, params) {
      // commit dashboard
      this.$glAuth.commitDashboard(dashboard, params)

      // close dropdown
      this.isDropdownOpen.dashboard = false
    },
    runReport () {
      let params = {}
      // bind params
      // _.forEach(this.params, (param, key) => {
      //   if (param.type === 'date' || param.type === 'text') params[key] = param.val
      //   else if (param.type === 'select') params[key] = param.value
      //   else if (param.type === 'multiselect') params[key] = _.map(param.val, (v) => { return v.value })
      // })

      _.forEach(this.paramValues, (param, key) => {
        if (_.isArray(param)) params[key] = _.map(param, 'value')
        else if (_.get(param, 'value')) params[key] = param.value
        else params[key] = param
      })

      // run report w/ params
      this.commitDashboard(this.dashboard.meta, params)
    },
    cancelChanges () {
      // emit cancel event
      this.$emit('cancel-changes')
    },
    submitChanges () {
      // emit submit event
      this.$emit('submit-changes')
    },
    scrollTop () {
      // scroll to the top of the window
      this.$glDom.scrollTop()
    },
    setRoute () {
      // get route
      let route = this.$glRouter.getCurrentRoute()

      // bind route.name
      this.route.name = _.isObject(route) ? route.name : ''

      // bind route.isSettingsPage
      this.route.isSettingsPage = (_.isObject(route) && _.includes(route.meta.is, 'settings'))
    },
    bindParamHeight () {
      Vue.nextTick(() => {
        let form = document.getElementsByClassName('gl-report-params__form')
        let paramHeight = _.get(form, '[0]') ? form[0].offsetHeight + 70 : 0

        // let Dashboard know param height
        this.$emit('param-height', paramHeight)

        // bind param height
        this.paramHeight = paramHeight + 'px'
      })
    },
    toggleReportParams () {
      // toggle areParamsVisible
      this.areParamsVisible = !this.areParamsVisible

      // update param height
      this.bindParamHeight()
    }
  }
}
</script>

<style lang="scss">
@import '../styles/colors';
@import '../styles/variables';

.gl-nav {
  $breakpoint: 900px;
  height: 66px;
  position: fixed;
  z-index: 20;
  width: 100%;
  border-bottom: 1px solid $gl-grey-border;

  &__logo,
  &__group,
  &__dashboard,
  &__profile,
  &__toggle-filters,
  &__report-params-toggle {
    position: relative;
    height: 65px;
    padding: $gl-gutter;

    @media (max-width: $breakpoint) {
      padding: $gl-gutter 10px;
    }
  }

  &__logo {
    min-width: 60px;
    max-width: 250px;
    padding: 15px 20px;
    border-right: 1px solid $gl-grey-border;

    @media (max-width: $breakpoint) {
      padding: 10px;
    }

    img {
      width: auto;
      max-height: 100%;
      max-width: 100%;
    }
  }

  &__group {
    border-right: 1px solid $gl-grey-border;

    &__logo {
      height: 32px;

      @media (max-width: $breakpoint) {
        display: none;
      }

      img {
        width: 32px;
        margin-right: 12px;
        max-height: 100%;
      }
    }

    &__name {
      font-size: 16px;
      font-weight: 700;
      color: $gl-grey-darker;
      white-space: nowrap;
    }
  }

  &__dashboard {
    border-right: 1px solid $gl-grey-border;

    &__icon {
      margin-right: 12px;
      width: 24px;
      height: 24px;
      border-radius: 100%;
      border: 1px solid $gl-grey-border;
    }

    &__name {
      font-size: 16px;
      font-weight: 700;
      color: $gl-grey-darker;
      white-space: nowrap;
    }
  }

  &__toggle-filters, &__report-params-toggle {
    cursor: pointer;
    border-left: 1px solid;
    &:hover {
      text-decoration: underline;
    }

    &__icon {
      margin-right: 10px;

      @media (max-width: $breakpoint) {
        margin-right: 0;
      }
    }

    &__label {
      font-weight: 700;
      font-size: 16px;
      line-height: 1.2;

      @media (max-width: $breakpoint) {
        display: none;
      }
    }
  }

  &__report-params-toggle {
    &__icon {
      opacity: 0.7;
    }
  }

  &__arrow {
    display: block;
    margin-left: 8px;

    .svg-inline--fa {
      transition: all 0.15s;
      font-size: 12px;
      margin-bottom: 1px;

      &.flip {
        transform: rotateX(180deg);
      }
    }
  }

  &__profile {
    text-decoration: none !important;
    border-left: 1px solid $gl-grey-border;

    &__dropdown-trigger {
      position: absolute;
      right: 0;
      left: 0;
      top: 0;
      bottom: 0;

      > button {
        width: 100%;
        height: 100%;
        background: transparent;
        border: none;
        cursor: pointer;
      }

      .dropdown-menu {
        max-height: 400px;
        overflow-y: auto;
      }

      .dropdown-item {
        &:focus {
          background-color: $gl-white;
        }
        &:hover {
          background-color: $gl-grey-smoke;
        }
      }
    }

    &__avatar {
      height: 34px;
      width: 34px;
      border-radius: 100%;
      margin-right: 12px;
      border: none;
      overflow: hidden;

      img {
        width: 100%;
      }
    }

    &__right {
      margin-right: 12px;
    }

    &__name {
      font-weight: 700;
      margin-bottom: 4px;
      color: $gl-grey-darker;
    }

    &__email {
      color: $gl-grey;
      font-weight: 400;
      font-size: 15px;
    }
  }

  &__changes {
    position: absolute;
    width: 100%;
    height: 100%;
    padding: 24px;
    background-color: rgba($gl-white, 0.1);

    &__message {
      color: $gl-black;
      font-weight: 600;
      font-size: 17px;
      background-color: $gl-white;
      padding: 6px 10px;
      border-radius: 2px;
      border: 1px solid $gl-grey-border-light;
    }
  }
}

.gl-report-params {
  height: 150px;
  position: fixed;
  top: 66px;
  z-index: 19;
  padding: $gl-gutter;
  width: 100%;
  border-bottom: 1px solid #D8D9DC;

  &__header {
    height: 24px;

    &__title {
      color: $gl-grey-darker;
      font-weight: 700;
      font-size: 20px;
    }

    &__close {
      font-size: 17px;
      &:hover {
        color: $gl-red;
      }
    }
  }

  &__form {

    &__param {
      margin: $gl-gutter $gl-gutter 0 0;
    }

    .form-group {
      margin: 0;
      border: none;
    }

    &__btn-wrapper {
      height: 90px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/gl-nav.vue